<template>
    <div class="btn-contact-switch" @click="open">
        <span class="keyboard-shortcut"> TAB </span>
        <span class="material-icons"> grid_view </span>
        <div class="add-button-text">{{ $t("chatWindow.live") }}</div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import SystemPubSub from "../../../utils/systemPubSub";

export default Vue.extend({
    name: "ContactSwitcherButton",
    computed: {
        ...mapState({}),
    },

    data() {
        return {};
    },
    methods: {
        ...mapActions({}),
        open(key) {
            SystemPubSub.publish(SystemPubSub.MESSAGE_TYPES.OPEN_CONTACT_SWITCH_SCREEN, {});
        },
    },
});
</script>

<style lang="scss">
.btn-contact-switch {
    display: flex;
    align-items: center;
    gap: 3px;
    width: fit-content !important;
    height: 32px;
    cursor: pointer;
    transition: all 0.3s;
    background: #fff;
    color: #22272d;
    font-family: Source Sans Pro, sans-serif;
    text-align: center;
    user-select: none;

    margin: unset !important;
    border-radius: 20px;
    border: 1px dashed var(--color-border-default);
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    padding: 1px 5px !important;
    min-width: fit-content;

    .keyboard-shortcut {
        margin-right: 3px;

        font-size: 0.8rem;
        font-weight: bold;
        color: #000;
        background-color: #f1f1f1;
        padding: 2px 5px;
        border-radius: 5px;
        border: 1px solid #ccc;
        width: max-content;
        height: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .material-icons {
        font-size: 15px;
        margin-right: 3px;
    }

    .material-icons {
        color: #000;
    }

    &:hover {
        opacity: 0.8;
    }
}
</style>
